// extracted by mini-css-extract-plugin
export default {"IsOverNonPdfSectionsTooltip":"_IsOverNonPdfSectionsTooltip--B77AU"};